/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetWishlistSuppliersQueryVariables = Exact<{
  companyId: string;
  role_assignment_id: string;
}>;


export type GetWishlistSuppliersQuery = { getWishlistSuppliers: { items: Array<{ id: string, supplier_id: string, created_at: string }> } | null };


export const GetWishlistSuppliersDocument = /*#__PURE__*/ gql`
    query GetWishlistSuppliers($companyId: uuid!, $role_assignment_id: uuid!) {
  getWishlistSuppliers(
    companyId: $companyId
    role_assignment_id: $role_assignment_id
  ) {
    items {
      id
      supplier_id
      created_at
    }
  }
}
    `;

/**
 * __useGetWishlistSuppliersQuery__
 *
 * To run a query within a React component, call `useGetWishlistSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWishlistSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWishlistSuppliersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      role_assignment_id: // value for 'role_assignment_id'
 *   },
 * });
 */
export function useGetWishlistSuppliersQuery(baseOptions: Apollo.QueryHookOptions<GetWishlistSuppliersQuery, GetWishlistSuppliersQueryVariables> & ({ variables: GetWishlistSuppliersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWishlistSuppliersQuery, GetWishlistSuppliersQueryVariables>(GetWishlistSuppliersDocument, options);
      }
export function useGetWishlistSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWishlistSuppliersQuery, GetWishlistSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWishlistSuppliersQuery, GetWishlistSuppliersQueryVariables>(GetWishlistSuppliersDocument, options);
        }
// @ts-ignore
export function useGetWishlistSuppliersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWishlistSuppliersQuery, GetWishlistSuppliersQueryVariables>): Apollo.UseSuspenseQueryResult<GetWishlistSuppliersQuery, GetWishlistSuppliersQueryVariables>;
export function useGetWishlistSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWishlistSuppliersQuery, GetWishlistSuppliersQueryVariables>): Apollo.UseSuspenseQueryResult<GetWishlistSuppliersQuery | undefined, GetWishlistSuppliersQueryVariables>;
export function useGetWishlistSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWishlistSuppliersQuery, GetWishlistSuppliersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWishlistSuppliersQuery, GetWishlistSuppliersQueryVariables>(GetWishlistSuppliersDocument, options);
        }
export type GetWishlistSuppliersQueryHookResult = ReturnType<typeof useGetWishlistSuppliersQuery>;
export type GetWishlistSuppliersLazyQueryHookResult = ReturnType<typeof useGetWishlistSuppliersLazyQuery>;
export type GetWishlistSuppliersSuspenseQueryHookResult = ReturnType<typeof useGetWishlistSuppliersSuspenseQuery>;
export type GetWishlistSuppliersQueryResult = Apollo.QueryResult<GetWishlistSuppliersQuery, GetWishlistSuppliersQueryVariables>;